export const getUniqueArray = <T extends number | string | boolean>(arr: T[]) => Array.from(new Set(arr));
export const mergeArraysUnique = <T extends number | string | boolean>(arr1: T[], arr2: T[]) =>
  getUniqueArray([...arr1, ...arr2]);
export const addArrayUnique = <T extends number | string | boolean>(arr1: T[], el: T) => getUniqueArray([...arr1, el]);
